<template>
  <div class="page-content">
    <div class="container-fluid">
      <!-- start page title -->
      <div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Produksi IKM</h4>

            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item">
                  <Link href="/admin/indagproduksiikm">Produksi IKM</Link>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <!-- end page title -->

      <div class="row">
        <div class="col-lg-12">
          <div class="card">
            <div class="card-body">
              <div class="d-flex justify-content-between">
                <div>
                  <h4 class="card-title">Manajemen Produksi IKM</h4>
                  <p class="card-title-desc mb-0">Data Sentra Industri Kecil dan Menengah.</p>
                </div>
                <div>
                  <button type="button" class="btn btn-success" @click="tambah">Tambah Baru</button>
                </div>
              </div>

              <hr>

              <data-attribut :data="indagproduksi">
                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th class="text-center" rowspan="2">No</th>
                        <th rowspan="2">Tahun</th>
                        <th rowspan="2">Nama Perusahaan / Pemilik</th>
                        <th class="text-center" rowspan="2">INVEST KONVER</th>
                        <th class="text-center" colspan="2">Kapasitas Produksi</th>
                        <th class="text-center" colspan="2">Kapasitas Pro-Konversi</th>
                        <th class="text-center" colspan="2">Niai Produksi</th>
                        <th class="text-center" colspan="3">Niai BB / Penolong</th>
                        <th class="text-center" rowspan="2">Aksi</th>
                      </tr>
                      <tr>
                        <th class="text-end">Jumlah</th>
                        <th>Satuan</th>
                        <th class="text-end">Jumlah</th>
                        <th>Satuan</th>
                        <th class="text-center">#</th>
                        <th class="text-center">Rasio</th>
                        <th class="text-center">#</th>
                        <th class="text-center">Rasio</th>
                        <th class="text-center">Rasio PDRB</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, index) in indagproduksi.data" :key="index">
                        <td scope="row" class="text-center">{{ indagproduksi.from + index }}</td>
                        <td scope="row" v-text="row.tahun"></td>
                        <td scope="row">
                          <div class="fw-bold" v-text="row.nama_perusahaan"></div>
                          <span v-text="row.kontak_person"></span>
                        </td>
                        <td scope="row" class="text-end" v-text="row.invest_konver"></td>
                        <td scope="row" class="text-end" v-text="row.produksi_volume"></td>
                        <td scope="row" v-text="row.produksi_satuan"></td>
                        <td scope="row" class="text-end" v-text="row.prokonversi_volume"></td>
                        <td scope="row" v-text="row.prokonversi_satuan"></td>
                        <td scope="row" class="text-end" v-text="row.produksi_nilai"></td>
                        <td scope="row" class="text-end" v-text="row.produksi_nilai_rasio"></td>
                        <td scope="row" class="text-end" v-text="row.nilai_penolong"></td>
                        <td scope="row" class="text-end" v-text="row.nilai_penolong_rasio"></td>
                        <td scope="row" class="text-end" v-text="row.nilai_penolong_rasio_pdrb"></td>
                        <td scope="row" class="text-center">
                          <a @click="edit(row)" class="p-0 btn btn-sm btn-link">Edit</a> |
                          <a @click="remove(row)" class="p-0 btn btn-sm btn-link">Hapus</a>
                        </td>
                      </tr>
                      <tr v-if="indagproduksi.data.length == 0">
                        <td scope="row" colspan="6" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </data-attribut>
            </div>
          </div>
        </div>
      </div>
      <!-- end row -->
    </div>
    <!-- container-fluid -->
  </div>

  <modal :show="form.show" @close="form.show = false" :title="(form.id ? 'Ubah' : 'Tambah') + ' Produksi'"
    backdrop="static" size="xl">
    <template #default>
      <form @submit.prevent="action">

        <div class="d-flex">
          <div class="p-3 pt-0 flex-fill">
            <div class="mb-2 row" v-if="!form.ikmsearch || ikm.hasdata">
              <label for="nama_perusaaan" class="col-sm-2 col-form-label">Nama Perusahaan</label>
              <div class="col-sm-10">
                <input type="text" readonly
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nama_perusaaan" v-model="form.data.nama_perusahaan">
              </div>
            </div>

            <div class="mb-2 row" v-if="!form.ikmsearch || ikm.hasdata">
              <label for="kontak_person" class="col-sm-2 col-form-label">Kontak Person</label>
              <div class="col-sm-9">
                <input type="text" readonly
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }" id="kontak_person"
                  v-model="form.data.kontak_person">
              </div>
              <div class="col-auto">
                <button class="btn btn-outline-danger" @click="ikm.hasdata = false" v-if="form.ikmsearch" type="button">X</button>
              </div>
            </div>

            <div v-if="form.ikmsearch && !ikm.hasdata">
              <form action="" method="post" @submit.prevent="cariIkm">
                <div class="d-flex gap-2 mb-2">
                  <input type="text" class="form-control" placeholder="Cari Data IKM ..." v-model="ikm.params.q">
                  <button class="btn btn-success" type="submit">
                    <icon :icon="['fa', 'search']" />
                  </button>
                </div>

                <div class="table-responsive">
                  <table class="table mb-0">
                    <thead>
                      <tr>
                        <th>No</th>
                        <th>Perusahaan</th>
                        <th>Kontak</th>
                        <th>Jenis Usaha</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(row, i) in ikm.data" :key="`ikm-${i}`">
                        <td v-text="i + 1"></td>
                        <td v-text="row.nama_perusahaan"></td>
                        <td v-text="row.kontak_person"></td>
                        <td v-text="row.jenis_produk"></td>
                        <td>
                          <button class="btn btn-sm btn-outline-success" @click="pilihIkm(row)" type="button">Pilih</button>
                        </td>
                      </tr>
                      <tr v-if="ikm.data.length == 0">
                        <td scope="row" colspan="4" class="text-center">
                          <i>Tidak ditemukan data!</i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </form>

            </div>

            <hr>

            <div class="mb-2 row">
              <label for="tahun" class="col-sm-2 col-form-label">Tahun</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="tahun" v-model="form.data.tahun">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="invest_konver" class="col-sm-2 col-form-label">INVEST KONVER</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="invest_konver" v-model="form.data.invest_konver">
              </div>
            </div>

            <hr>

            <div class="row">
              <div class="col">
                <div class="mb-3">
                  <label for="produksi_volume_Satuan" class="form-label">Kapasitas Produksi</label>
                  <div class="mb-2 row">
                    <label for="produksi_volume" class="col-sm-4 col-form-label">Volume</label>
                    <div class="col-sm-8">
                      <input type="text" :readonly="form.readonly"
                        :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                        id="produksi_volume" v-model="form.data.produksi_volume">
                    </div>
                  </div>
                  <div class="mb-2 row">
                    <label for="produksi_satuan" class="col-sm-4 col-form-label">Satuan</label>
                    <div class="col-sm-8">
                      <input type="text" :readonly="form.readonly"
                        :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                        id="produksi_satuan" v-model="form.data.produksi_satuan">
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="mb-3">
                  <label for="prokonversi_volume_satuan" class="form-label">Kapasitas Pro-Konversi</label>
                  <div class="mb-2 row">
                    <label for="prokonversi_volume" class="col-sm-4 col-form-label">Volume</label>
                    <div class="col-sm-8">
                      <input type="text" :readonly="form.readonly"
                        :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                        id="prokonversi_volume" v-model="form.data.prokonversi_volume">
                    </div>
                  </div>
                  <div class="mb-2 row">
                    <label for="prokonversi_satuan" class="col-sm-4 col-form-label">Satuan</label>
                    <div class="col-sm-8">
                      <input type="text" :readonly="form.readonly"
                        :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                        id="prokonversi_satuan" v-model="form.data.prokonversi_satuan">
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <hr>

            <div class="mb-2 row">
              <label for="produksi_nilai" class="col-sm-2 col-form-label">Niai Produksi</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="produksi_nilai" v-model="form.data.produksi_nilai">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="produksi_nilai_rasio" class="col-sm-2 col-form-label">Niai Produksi Rasio</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="produksi_nilai_rasio" v-model="form.data.produksi_nilai_rasio">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nilai_penolong" class="col-sm-2 col-form-label">Niai BB / Penolong</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nilai_penolong" v-model="form.data.nilai_penolong">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nilai_penolong_rasio" class="col-sm-2 col-form-label">Niai BB / Penolong Rasio</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nilai_penolong_rasio" v-model="form.data.nilai_penolong_rasio">
              </div>
            </div>

            <div class="mb-2 row">
              <label for="nilai_penolong_rasio_pdrb" class="col-sm-2 col-form-label">Niai BB / Penolong Rasio PDRB</label>
              <div class="col-sm-10">
                <input type="text" :readonly="form.readonly"
                  :class="{ 'form-control-plaintext': form.readonly, 'form-control': !form.readonly }"
                  id="nilai_penolong_rasio_pdrb" v-model="form.data.nilai_penolong_rasio_pdrb">
              </div>
            </div>
            

          </div>

          <div>
            <div class="d-grid gap-2 flex-row">
              <button type="button" v-if="form.readonly && form.id" @click="form.readonly = false"
                class="btn btn-outline-success">Ubah</button>
              <button type="submit" v-if="!form.readonly" class="btn btn-success">Simpan</button>
              <button type="button" v-if="!form.readonly && form.id" @click="form.readonly = true"
                class="btn btn-danger">Batal</button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </modal>
</template>

<script>
import Layout from '@/layout/Index'
import Modal from '@/components/Modal'
import DataAttribut from '@/components/DataAttribut'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'
import axios from 'axios'

export default {
  layout: Layout,
  components: { Modal, DataAttribut },
  props: {
    indagproduksi: Object
  },
  data() {
    return {
      ikm: {
        hasdata: false,
        params: {
          q: '',
        },
        data: []
      },
      form: {
        show: false,
        id: null,
        readonly: true,
        ikmsearch: false,
        data: {}
      },
    }
  },
  methods: {
    cariIkm() {
      if(this.ikm.params.q) {
        axios.get('/admin/indagikm', {
          params: this.ikm.params
        })
        .then(res => {
          this.ikm.data = res.data.indagikm.data;
        }).catch(() => {});
      } else {
        this.ikm.data = [];
      }
    },
    pilihIkm(row) {
      this.form.data.nama_perusahaan = row.nama_perusahaan;
      this.form.data.kontak_person = row.kontak_person;
      this.form.data.ikm_id = row.id;
      this.ikm.hasdata = true;
    },
    tambah() {
      this.form.id = null;
      this.form.show = true;
      this.form.readonly = false;
      this.form.data = {};
      this.form.ikmsearch = true;
      this.ikm.hasdata = false;
    },
    edit({ id }) {
      this.form.id = id;
      this.form.show = true;
      this.form.readonly = true;
      this.form.ikmsearch = false;
      axios.get('/admin/indagproduksiikm/' + id)
        .then(res => {
          this.form.data = res.data.indagproduksi || {};
        })
    },
    action() {
      const onSuccess = () => {
        this.form.show = false;
        this.form.id = null;
        this.form.ikm_id = null;
        this.form.data = {};
      }
      if (this.form.id) {
        this.$inertia.put('/admin/indagproduksiikm/' + this.form.id, this.form.data, { onSuccess });
      } else {
        this.$inertia.post('/admin/indagproduksiikm', this.form.data, { onSuccess });
      }
    },
    remove(row) {
      if(confirm('Konfirmasi Proses Penghapusan?'))
      this.$inertia.delete('/admin/indagproduksiikm/' + row.id);
    }
  },
}
</script>
